export const DefaultColumnHeaderSortIcon = () => null;
